import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import WebsiteChat from "../website-chat/WebsiteChat";
import WebsiteInquiries from "../website-inquiries/WebsiteInquiries";
import "./MessagesHub.css";

function readModules() {
  try {
    const stored = JSON.parse(localStorage.getItem("userModules") || "{}");
    return Array.isArray(stored.modules)
      ? stored.modules.map((module) => String(module).toLowerCase())
      : [];
  } catch {
    return [];
  }
}

function MessagesHub() {
  const { id: inquiryId } = useParams();
  const modules = useMemo(readModules, []);
  const canReadTablee = modules.includes("mensajes_sitio")
    || modules.includes("mensajes del sitio");
  const canReadOliva = modules.includes("oliva_contacts");
  const availableTabs = [
    ...(canReadTablee ? ["tablee"] : []),
    ...(canReadOliva ? ["oliva"] : []),
  ];
  const [activeTab, setActiveTab] = useState(
    inquiryId && canReadOliva ? "oliva" : (availableTabs[0] || "")
  );

  if (!activeTab) {
    return (
      <main className="messages-hub">
        <div className="messages-hub__empty">
          No tienes permisos para acceder a las conversaciones.
        </div>
      </main>
    );
  }

  return (
    <main className="messages-hub">
      <header className="messages-hub__header">
        <div>
          <span>Centro de comunicaciones</span>
          <h1>Mensajes</h1>
          <p>Conversaciones de todos nuestros negocios en un solo lugar.</p>
        </div>
        {canReadTablee && activeTab === "tablee" ? (
          <a className="messages-hub__settings" href="/app/conversaciones/configuracion">
            <span className="material-symbols-outlined">settings</span>
            <span>Configurar chat</span>
          </a>
        ) : null}
      </header>

      <div className="messages-hub__workspace">
        <nav className="messages-hub__businesses" aria-label="Filtrar mensajes por negocio">
          {canReadTablee ? (
            <button
              type="button"
              className={activeTab === "tablee" ? "is-active" : ""}
              onClick={() => setActiveTab("tablee")}
              aria-label="Mostrar conversaciones del sitio"
              aria-pressed={activeTab === "tablee"}
              title="Chat web"
            >
              <span className="material-symbols-outlined" aria-hidden="true">chat</span>
              <span>Chat web</span>
            </button>
          ) : null}
          {canReadOliva ? (
            <button
              type="button"
              className={activeTab === "oliva" ? "is-active" : ""}
              onClick={() => setActiveTab("oliva")}
              aria-label="Mostrar mensajes de Oliva y Miel"
              aria-pressed={activeTab === "oliva"}
              title="Oliva y Miel"
            >
              <img src="/ovm_logo.png" alt="" aria-hidden="true" />
              <span>Oliva y Miel</span>
            </button>
          ) : null}
        </nav>

        <section className="messages-hub__content">
          {activeTab === "tablee" ? <WebsiteChat /> : <WebsiteInquiries />}
        </section>
      </div>
    </main>
  );
}

export default MessagesHub;
